import { Inject, Injectable, PipeTransform } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { NgForm } from '@angular/forms';
import { map, switchMap } from 'rxjs/operators';
import { plainToClass, plainToClassFromExist, TransformPlainToClass } from 'class-transformer';
import { DecimalPipe } from '@angular/common';
import { IEntity } from '@interfaces/entity';
import { IEntityService } from '@interfaces/entityService';
import { TableColumn } from '@models/tableColumn';
import { UserDto } from '@dto/userDto';
//import { DeleteEntitiesDto } from '@models/dto/deleteEntitiesDto';


@Injectable({
  providedIn: 'root'
})
export abstract class EntityService implements IEntityService {

  public abstract entityRoute;

  constructor(public http: HttpClient, @Inject('BASE_URL') public baseUrl: string) {
  }

  // API Requests

  getEntities(params?): Observable<IEntity[]> {
    return this.http.get<IEntity[]>(this.baseUrl + 'api/' + this.entityRoute, { params: params });
  }

  getEntity(primaryKey): Observable<IEntity> {
    return this.http.get<IEntity>(this.baseUrl + 'api/' + this.entityRoute + '/' + primaryKey);
  }

  async getEntityAsync(primaryKey): Promise<IEntity> {
    return await this.http.get<IEntity>(this.baseUrl + 'api/' + this.entityRoute + '/' + primaryKey).toPromise();
  }

  createEntity(entity: IEntity, params?): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'api/' + this.entityRoute, entity, { params: params });
  }

  updateEntity(entity: IEntity): Observable<IEntity> {
    return this.http.put<IEntity>(this.baseUrl + 'api/' + this.entityRoute + '/' + entity.getPrimaryKey(), entity);
  }

  patchEntity(id: string | number, body) {
    return this.http.patch(this.baseUrl + 'api/' + this.entityRoute + '/' + id, body);
  }

  patchEntityWithEndpoint(id: string | number, endpoint: string, body) {
    return this.http.patch(this.baseUrl + 'api/' + this.entityRoute + '/' + id + '/' + endpoint, body);
  }

  deleteEntity(primaryKey): Observable<IEntity> {
    return this.http.delete<IEntity>(this.baseUrl + 'api/' + this.entityRoute + '/' + primaryKey);
  }


  //deleteEntities(deleteEntitiesDto: DeleteEntitiesDto): Observable<any> {
  //  let options = {
  //    headers: new HttpHeaders(),
  //    body: deleteEntitiesDto,
  //  };

  //  return this.http.delete<any>(this.baseUrl + 'api/' + this.entityRoute, options);
  //}

  getData(url: string) {
    return this.http.get(this.baseUrl + url);
  }

}
